/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateRouteRequestBody,
  UpdateRouteRequestBody$Outbound,
  UpdateRouteRequestBody$outboundSchema,
} from "../components/updaterouterequestbody.js";

export type UpdateDataExportRouteSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateDataExportRouteSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateDataExportRouteSecurity = {
  option1?: UpdateDataExportRouteSecurityOption1 | undefined;
  option2?: UpdateDataExportRouteSecurityOption2 | undefined;
};

export type UpdateDataExportRouteRequest = {
  /**
   * Route ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateRouteRequestBody: UpdateRouteRequestBody;
};

/** @internal */
export type UpdateDataExportRouteSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateDataExportRouteSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateDataExportRouteSecurityOption1$Outbound,
  UpdateDataExportRouteSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateDataExportRouteSecurityOption1ToJSON(
  updateDataExportRouteSecurityOption1: UpdateDataExportRouteSecurityOption1,
): string {
  return JSON.stringify(
    UpdateDataExportRouteSecurityOption1$outboundSchema.parse(
      updateDataExportRouteSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateDataExportRouteSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateDataExportRouteSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateDataExportRouteSecurityOption2$Outbound,
  UpdateDataExportRouteSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateDataExportRouteSecurityOption2ToJSON(
  updateDataExportRouteSecurityOption2: UpdateDataExportRouteSecurityOption2,
): string {
  return JSON.stringify(
    UpdateDataExportRouteSecurityOption2$outboundSchema.parse(
      updateDataExportRouteSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateDataExportRouteSecurity$Outbound = {
  Option1?: UpdateDataExportRouteSecurityOption1$Outbound | undefined;
  Option2?: UpdateDataExportRouteSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateDataExportRouteSecurity$outboundSchema: z.ZodMiniType<
  UpdateDataExportRouteSecurity$Outbound,
  UpdateDataExportRouteSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateDataExportRouteSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateDataExportRouteSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateDataExportRouteSecurityToJSON(
  updateDataExportRouteSecurity: UpdateDataExportRouteSecurity,
): string {
  return JSON.stringify(
    UpdateDataExportRouteSecurity$outboundSchema.parse(
      updateDataExportRouteSecurity,
    ),
  );
}

/** @internal */
export type UpdateDataExportRouteRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateRouteRequestBody: UpdateRouteRequestBody$Outbound;
};

/** @internal */
export const UpdateDataExportRouteRequest$outboundSchema: z.ZodMiniType<
  UpdateDataExportRouteRequest$Outbound,
  UpdateDataExportRouteRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateRouteRequestBody: UpdateRouteRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateRouteRequestBody: "UpdateRouteRequestBody",
    });
  }),
);

export function updateDataExportRouteRequestToJSON(
  updateDataExportRouteRequest: UpdateDataExportRouteRequest,
): string {
  return JSON.stringify(
    UpdateDataExportRouteRequest$outboundSchema.parse(
      updateDataExportRouteRequest,
    ),
  );
}
